<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Review Sick Cows
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>
    <template v-if="!removed">
      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('avg_per_cow_spend_vet_exam') ? 'subsection-disabled' : ''">
          <u>Avg. Per Cow Spend on Vet Examinations (VFD 115) </u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'avg_per_cow_spend_vet_exam')">
            <span class="glyphicon" :class="isRemovedSubsection('avg_per_cow_spend_vet_exam') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <h4>Period 1 st June – 31 st October</h4>
        <bar :chart-data="chartData" :options="chartOptions" ref="avg_spend_on_vet_exams"></bar>
      </div>

      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('vet_exams') ? 'subsection-disabled' : ''">
          <u>Vet Examinations (VFD 115)</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'vet_exams')">
            <span class="glyphicon" :class="isRemovedSubsection('vet_exams') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <h4>Period 1st June – 31st October 4 Seasons</h4>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Date</th>
              <th>Spend</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rv, index) in model.CHARTS.sick_cows_table" :key="index"
              :class="getRowClass(model.CHARTS.sick_cows_table, 'Date', index)">

              <td class="text-left">{{ rv["Date"] }}</td>
              <td class="text-left">{{ rv["Spend"] }}</td>
              <td class="text-left">{{ rv["Description"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-left step-section">
        <dl class="dl-horizontal">
          <dt>Key Points</dt>
          <dd>{{ model.sickcows_keypoints || '-'}}</dd>

          <dt>Actions</dt>
          <dd>{{ model.sickcows_actions || '-'}}</dd>
        </dl>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'
import Bar from '../../charts/Bar'

export default {
  mixins: [ mixin ],
  props: ['model'],
  components: {
    Bar,
  },
  data() {
    return {
      stepName: 'ReviewSickCows',
    }
  },
  computed: {
    chartOptions: function () {
      return {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Dollars'
            }
          }]
        }
      }
    },
    chartData: function () {
      return {
        labels: this.model.CHARTS.sick_cows.map(row => row['Season']),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.sick_cows.map(row => row['Per Cow Spend']),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.sick_cows.map(row => row['Region Avg. Per Cow Spend']),
          },
        ],
      }
    },
  },
};
</script>
